export default "__VITE_ASSET__9e565cc3__"